import { Injectable } from '@angular/core';
import { LoaderState } from '../interfaces/loader-state';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private loaderSubject = new Subject<LoaderState>();
  public loaderState = this.loaderSubject.asObservable();

  constructor() { }

  public show() {
    this.loaderSubject.next(<LoaderState>{ show: true });
  }

  public hide() {
    this.loaderSubject.next(<LoaderState>{ show: false });
  }
}
